export default __webpack_public_path__ + "static/media/23.5fb04689.jpg";